// test2545
(2545 && 0);
